import { stringify } from 'qs';
import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let ServiceItemController = {
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-item/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-item/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-item/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detail: (productId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-item/detail/${productId}`,
            method: 'GET'
        }, callback)
    },
}

export default ServiceItemController
